import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, RouteComponentProps, useLocation } from 'react-router-dom';
import HomeComponent from '../components/dashboard';
import ChatComponent from '../components/chat';
import AppointmentComponent from '../components/Appointment';
import RecordsComponent from '../components/Records';
import CartComponent from '../components/Cart';
import LogoutComponent from '../components/Logout';
import HelpComponent from '../components/VcSupport/pages/HelpComponent';
import Privacy from '../components/Privacy';
import VcSupportComponent from '../components/VcSupport';
import VcSupportAppointment from '../components/VcSupport/pages/Appointment';
import VcSupportAppointmentLists from '../components/VcSupport/pages/AppointmentLists';
import VcSupportContactUs from '../components/VcSupport/pages/ContactUs';
import Doctors from '../components/Doctors';
import { Loader } from 'shared';

export type IProps = RouteComponentProps;

function ProtectedRoutes({
  history,
}: IProps) {
  const { accessToken } = useSelector(state => state.auth);
  const location = useLocation();

  useEffect(() => {
    const nextRoute = `${location.pathname}${location.search}`;
    console.log('object location', nextRoute);
    if (!accessToken) history.replace('/');
  }, [accessToken]);

  if (!accessToken) return <Loader height='100vh' iconSize={50} />;

  return (
    <>
      <Route exact path={'/dashboard'} component={HomeComponent} />
      <Route exact path={'/chat'} component={ChatComponent} />
      <Route exact path={'/doctors'} component={Doctors} />
      <Route exact path={'/appointment'} component={AppointmentComponent} />
      <Route exact path={'/logout'} component={LogoutComponent} />
      <Route exact path={'/records'} component={RecordsComponent} />
      <Route exact path={'/cart'} component={CartComponent} />
      <Route exact path={'/support/help'} component={HelpComponent} />
      <Route exact path={'/support/privacy'} component={Privacy} />
      <Route exact path={'/support/appointment/:appointmentId'} component={VcSupportAppointment} />
      <Route exact path={'/support/appointment'} component={VcSupportAppointmentLists} />
      <Route exact path={'/support/contactus'} component={VcSupportContactUs} />
      <Route exact path={'/support'} component={VcSupportComponent} />
    </>
  );
}

export default ProtectedRoutes;